export default "__VITE_ASSET__50383846__"